function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.438,
    height: 15.471,
    viewBox: "0 0 15.438 15.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "phone-call (4)",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19811"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16309",
    d: "m15.573 11.354-2.159-2.159a1.436 1.436 0 0 0-2.39.54 1.469 1.469 0 0 1-1.7.925 6.658 6.658 0 0 1-4.01-4.01 1.4 1.4 0 0 1 .925-1.7 1.436 1.436 0 0 0 .54-2.39L4.623.4a1.54 1.54 0 0 0-2.081 0L1.077 1.87c-1.466 1.542.154 5.63 3.778 9.253s7.711 5.32 9.253 3.778l1.465-1.465a1.54 1.54 0 0 0 0-2.082z",
    transform: "translate(-.539)",
    style: {
      fill: "#7c7c7c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.6da0bc80c19bfebbb6fb026257501dd3.svg";
export { ForwardRef as ReactComponent };